import {
  OreCardActions,
  OreCardContainer,
  OreCardWrapper,
  OreStack,
} from '@edenredespana/oreneta'
import { FormProvider } from 'react-hook-form'

import { Step1Actions, Step1Form, Step1NoPhones } from '../atoms'
import { useBankAccount } from '../context'

export const ChangeBankAccountStep1 = (): JSX.Element => {
  const { changeForm, availablePhones } = useBankAccount()

  return (
    <FormProvider {...changeForm}>
      <form>
        <OreStack placeContent="stretch" space="large">
          <OreCardContainer>
            <OreCardWrapper>
              <OreStack placeContent="stretch" space="large">
                {availablePhones && availablePhones.length > 0 ? (
                  <Step1Form />
                ) : (
                  <Step1NoPhones />
                )}
              </OreStack>
            </OreCardWrapper>
            <OreCardActions>
              <Step1Actions simplified={availablePhones.length === 0} />
            </OreCardActions>
          </OreCardContainer>
        </OreStack>
      </form>
    </FormProvider>
  )
}
